export default talksConfig;

/** @ngInject */
function talksConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Rozmowy',
    state: 'modules.talks',
    showInMenu: true,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.talks', {
      url: '/talks',
      views: {
        'content@': {
          component: 'talksComponent'
        }
      },
      resolve: {
        talks: TalkService => TalkService.getAll(true)
      }
    })
    .state('modules.talks.add', {
      url: '/add',
      data: {
        title: 'Dodaj nową rozmowę',
        displayName: 'Dodaj nową rozmowę'
      },
      views: {
        'content@': {
          component: 'addTalkComponent'
        }
      },
      resolve: {
        students: StudentService => StudentService.getAll()
      }
    })
    .state('modules.talks.edit', {
      url: '/edit/:id',
      data: {
        title: 'Edytuj rozmowę',
        displayName: 'Edytuj rozmowę'
      },
      views: {
        'content@': {
          component: 'editTalkComponent'
        }
      },
      resolve: {
        talk: (TalkService, $stateParams) => TalkService.get($stateParams.id)
      }
    });
}
